import { FC } from 'react'
import { classNames } from '@g4g/utils/src/react/class-names'
import NumberPicker from '@g4g/ui/src/components/NumberPicker'
import { CART_QUANTITY_MAXIMUM } from '../util/cart'

const QuantitySelect: FC<{
  cartQuantity: number
  selected: number
  onChange: (n: number) => void
  placeholder?: string
  buttonClassName?: string
  inputClassName?: string
  disabled?: boolean
  allowZeroQty?: boolean
}> = ({
  cartQuantity,
  inputClassName,
  selected,
  onChange,
  placeholder,
  buttonClassName,
  disabled,
  allowZeroQty,
}) => {
  const quantityLimit = cartQuantity === -1 ? CART_QUANTITY_MAXIMUM : cartQuantity
  const _lowLimit = quantityLimit <= 1 && !allowZeroQty
  const _disabled = disabled || _lowLimit
  if (_lowLimit) {
    return <div data-cy="shop-cart-product-qty">{selected}</div>
  }
  return (
    <NumberPicker
      label="Pick a quantity"
      onChange={onChange}
      disabled={_disabled}
      buttonClassName={classNames(
        buttonClassName,
        'disabled:border-white/20 disabled:text-opacity-40',
        'enabled:border-white/30 enabled:hover:border-white/80',
        'flex border text-xl items-center',
        'text-white'
      )}
      value={selected}
      placeholder={placeholder}
      inputClassName={classNames(
        inputClassName,
        'flex bg-transparent items-center',
        'justify-center text-center',
        // rounded-none because on safari it rounds for some reason otherwise.
        'border-t border-b border-white/30 rounded-none'
      )}
      className={'flex'}
      min={allowZeroQty ? 0 : 1}
      max={quantityLimit}
    />
  )
}

export default QuantitySelect
